import { OPERATOR_PANEL_INFORMATION_SCREENS } from '@components/operatorPanel/constants/operatorPanel.constants';
import { OPTabRequirementsContext } from '@components/operatorPanel/interfaces';

export const getInitialOPInformationScreen = (ctx: OPTabRequirementsContext): OPERATOR_PANEL_INFORMATION_SCREENS => {
  if (ctx.isMachinePerspective) {
    if (!ctx.notUnknownNcFile) return OPERATOR_PANEL_INFORMATION_SCREENS.NcFiles;
    if (!ctx.erp) return OPERATOR_PANEL_INFORMATION_SCREENS.SearchNCFiles;
  }
  return OPERATOR_PANEL_INFORMATION_SCREENS.Jobs;
};
